import _ from 'lodash';
import * as yup from 'yup';

export default yup.object().shape({
    company: yup.object().shape({
        type: yup.string().required(),
        company_name: yup.string(),
        crefo_id: yup.string().required(),
        annual_business_profit: yup.number().when('type', {
            is: (type) => type === 'st' || type === 'op' || type === 'other',
            then: () => yup.number().required(),
            otherwise: () =>
                yup
                    .number()
                    .transform(() => null)
                    .required()
        }),
        is_registered: yup.boolean(),
        providers: yup.array().min(1),
        annual_turnover: yup.number().required(),
        website: yup.string().required(),
        vat_registered_status: yup.boolean().required(),
        online_sales_percentage: yup.number().required(),
        registered: yup.string().required()
    }),
    people: yup
        .array()
        .when('company.type', {
            is: (type) => type === 'st' || type === 'op' || type === 'other',
            then: () =>
                yup.array().of(
                    yup.object().shape({
                        first_name: yup.string().required(),
                        last_name: yup.string().required(),
                        title: yup.string().required(),
                        date_of_birth: yup.string().required(),
                        email: yup.string().email().required(),
                        roles: yup.array(),
                        marketing_emails: yup.boolean().required(),
                        privacy_policy_agreement_date: yup.date().required(),
                        phone: yup
                            .array()
                            .of(
                                yup
                                    .object()
                                    .shape({
                                        type: yup.string().required(),
                                        number: yup.string().required()
                                    })
                                    .transform((phone) =>
                                        !_.isEmpty(phone.number) ? phone : null
                                    )
                                    .required()
                            )
                            .transform((phones) => {
                                const numbers = _.filter(
                                    phones,
                                    (phone) => phone.number
                                );
                                return numbers.length ? phones : null;
                            })
                            .required(),
                        addresses: yup.array().when('roles', {
                            is: (roles) => _.includes(roles, 'applicant'),
                            then: () =>
                                yup
                                    .array()
                                    .of(
                                        yup.object().shape({
                                            street_line_1: yup
                                                .string()
                                                .required(),
                                            town: yup.string().required(),
                                            postcode: yup.string().required(),
                                            residential_status: yup
                                                .string()
                                                .required(),
                                            auto: yup
                                                .boolean()
                                                .transform(() => null)
                                                .required()
                                        })
                                    )
                                    .transform((addresses) => {
                                        const postcodes = _.filter(
                                            addresses,
                                            (address) => address.postcode
                                        );
                                        return postcodes.length
                                            ? addresses
                                            : null;
                                    })
                                    .required(),
                            otherwise: () =>
                                yup
                                    .array()
                                    .of(
                                        yup.object().shape({
                                            street_line_1: yup
                                                .string()
                                                .required(),
                                            town: yup.string().required(),
                                            postcode: yup.string().required(),
                                            auto: yup
                                                .boolean()
                                                .transform(() => null)
                                                .required()
                                        })
                                    )
                                    .transform((addresses) => {
                                        const postcodes = _.filter(
                                            addresses,
                                            (address) => address.postcode
                                        );
                                        return postcodes.length
                                            ? addresses
                                            : null;
                                    })
                                    .required()
                        })
                    })
                ),
            otherwise: () =>
                yup.array().of(
                    yup.object().shape({
                        first_name: yup.string().required(),
                        last_name: yup.string().required(),
                        title: yup.string().required(),
                        email: yup.string().email().required(),
                        date_of_birth: yup.string().required(),
                        roles: yup.array(),
                        marketing_emails: yup.boolean().required(),
                        privacy_policy_agreement_date: yup.date().required(),
                        phone: yup
                            .array()
                            .of(
                                yup
                                    .object()
                                    .shape({
                                        type: yup.string().required(),
                                        number: yup.string().required()
                                    })
                                    .transform((phone) =>
                                        !_.isEmpty(phone.number) ? phone : null
                                    )
                                    .required()
                            )
                            .transform((phones) => {
                                const numbers = _.filter(
                                    phones,
                                    (phone) => phone.number
                                );
                                return numbers.length ? phones : null;
                            })
                            .required(),
                        addresses: yup
                            .array()
                            .of(
                                yup
                                    .object()
                                    .shape({
                                        street_line_1: yup.string().required(),
                                        town: yup.string().required(),
                                        postcode: yup.string().required(),
                                        residential_status: yup
                                            .string()
                                            .required(),
                                        auto: yup
                                            .boolean()
                                            .transform(() => null)
                                            .required()
                                    })
                                    .required()
                            )
                            .transform((addresses) => {
                                const postcodes = _.filter(
                                    addresses,
                                    (address) => address.postcode
                                );
                                return postcodes.length ? addresses : null;
                            })
                            .required()
                    })
                )
        })
        .required(),
    loan_request: yup
        .object()
        .shape({
            urgency: yup.string().required(),
            amount: yup.number().required(),
            purpose: yup.string().when('urgency', {
                is: 'future_use',
                then: () => yup.string().transform(() => null),
                otherwise: () => yup.string().required()
            }),
            detailed_reason: yup.string().when('purpose', {
                is: (purpose) => purpose === 'other',
                then: () => yup.string().required(),
                otherwise: () =>
                    yup
                        .string()
                        .transform(() => null)
                        .required()
            })
        })
        .transform((obj) => {
            const v = _.values(obj).filter((v) => !_.isEmpty(v));
            return v.length ? obj : null;
        })
        .required()
});
